import type {
  HotelSelectionFilterAppliedMetadata,
  HotelSelectionFilterClosedMetadata,
  HotelSelectionFilterOpenedMetadata,
  HotelSelectionFilterRemovedMetadata,
  HotelSelectionFilterResetMetadata,
  HotelSelectionInitiatedMetadata,
} from '@apps/main/new-desktop/core/models';

export const enum HotelSelectionEventType {
  Initialized = 'initialized',
  OpenFilters = 'openFilters',
  CloseFilters = 'closeFilters',
  ApplyFilter = 'applyFilters',
  RemoveFilter = 'removeFilters',
  ResetFilter = 'resetFilters',
}

export interface HotelSelectionInitiatedEvent {
  type: HotelSelectionEventType.Initialized;
  data: HotelSelectionInitiatedMetadata;
}

export interface HotelSelectionFilterOpenedEvent {
  type: HotelSelectionEventType.OpenFilters;
  data: HotelSelectionFilterOpenedMetadata;
}

export interface HotelSelectionFilterClosedEvent {
  type: HotelSelectionEventType.CloseFilters;
  data: HotelSelectionFilterClosedMetadata;
}

export interface HotelSelectionFilterAppliedEvent {
  type: HotelSelectionEventType.ApplyFilter;
  data: HotelSelectionFilterAppliedMetadata;
}

export interface HotelSelectionFilterRemovedEvent {
  type: HotelSelectionEventType.RemoveFilter;
  data: HotelSelectionFilterRemovedMetadata;
}

export interface HotelSelectionFilterResetEvent {
  type: HotelSelectionEventType.ResetFilter;
  data: HotelSelectionFilterResetMetadata;
}

export type HotelSelectionEventTypes =
  | HotelSelectionInitiatedEvent
  | HotelSelectionFilterOpenedEvent
  | HotelSelectionFilterClosedEvent
  | HotelSelectionFilterAppliedEvent
  | HotelSelectionFilterRemovedEvent
  | HotelSelectionFilterResetEvent;
